
import { AxiosInstance } from "axios";

const updateClient = async (email: string, zipcode: string, state: string, axiosInstance: AxiosInstance) => {

        try {
            const response = await axiosInstance
                .put('/client', {
                    email,
                    zipcode,
                    state
                });
            return response.data;
        } catch (error: any) {
            if (error.response && error.response.data && error.response.data.message) {
                return error.response.data.message;
            } else {
                return error.message;
            }
        }  
}

export {updateClient};